import request from '@/router/axios';
export var getUsualList = function getUsualList(current, size) {
  return request({
    url: '/api/blade-log/usual/list',
    method: 'get',
    params: {
      current: current,
      size: size
    }
  });
};
export var getApiList = function getApiList(current, size) {
  return request({
    url: '/api/blade-log/api/list',
    method: 'get',
    params: {
      current: current,
      size: size
    }
  });
};
export var getErrorList = function getErrorList(current, size) {
  return request({
    url: '/api/blade-log/error/list',
    method: 'get',
    params: {
      current: current,
      size: size
    }
  });
};
export var getUsualLogs = function getUsualLogs(id) {
  return request({
    url: '/api/blade-log/usual/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var getApiLogs = function getApiLogs(id) {
  return request({
    url: '/api/blade-log/api/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var getErrorLogs = function getErrorLogs(id) {
  return request({
    url: '/api/blade-log/error/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};